import React from 'react'
import bg from '../../../public/static/image-background/logo-v-02.png'
import config from '../../../constants/config'
import { getBase64, formatDateTime, useTranslation } from '../../../constants/helpers'

const PlayersList10 = ({ id, players, league, size, setIsReady, isShowBirthDay, seasonData, teamData, checkboxPlayer, checkboxStaff, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = width / 100
    const sizeItemLogo = px * 15
    const [listUser, setListUser] = React.useState([])

    const color = {
        first: '#FFD700',    // Metallic Gold
        second: '#FFF0A0',   // Pale Gold
        third: '#B8860B',    // Dark Gold
        fourth: '#e0c060',   // Muted Gold
        text: '#ffffff',
        subText: 'rgba(255,240,160,0.75)',
        bg: '#0a0a0a',       // Jet Black
        staffBorder: '#FFD700',
        playerBorder: '#B8860B'
    }

    // Responsive font size – compact, no wrapping
    const nameFontSize = (name, base) => {
        if (!name) return `${base}px`
        if (name.length > 18) return `${base * 0.7}px`
        if (name.length > 13) return `${base * 0.85}px`
        return `${base}px`
    }

    const listPlayer = players?.reduce(
        (p, c) => {
            if (!p[c.types]) p[c.types] = []
            if (c.types?.length > 1) {
                p['football_player_type'].push(c)
                p['football_staff_type'].push(c)
                return p
            }
            p[c.types].push(c)
            return p
        },
        { football_player_type: [], football_staff_type: [] }
    )

    const arrPriority = ['football_team_manager', 'football_coach', 'football_coach_assistant', 'football_medical_staff', 'football_marketing', 'football_other_staff']
    const maxSortIndex = arrPriority?.length
    const _staffs = listPlayer?.football_staff_type
        ?.map(item => {
            const positions = item?.positions
                ?.map(i => {
                    const sortIndex = arrPriority.findIndex(p => p == i)
                    return { value: i, sortIndex: sortIndex == -1 ? maxSortIndex : sortIndex }
                })
                .sort((a, b) => a.sortIndex - b.sortIndex)
                ?.map(p => p.value)
            const sortIndex = arrPriority?.findIndex(p => p == positions[0])
            return { ...item, positions, sortIndex: sortIndex == -1 ? maxSortIndex : sortIndex }
        })
        .sort((a, b) => a.sortIndex - b.sortIndex)

    const onLoaded = value => {
        setListUser(s => [...s, value])
    }

    React.useEffect(() => {
        if (listUser?.length === listPlayer?.football_staff_type?.length + listPlayer.football_player_type?.length) {
            setIsReady?.(true)
        }
    }, [listUser])

    const staffPosition = {
        football_coach: t('football_coach'),
        football_coach_assistant: t('football_coach_assistant'),
        football_marketing: t('football_marketing'),
        football_medical_staff: t('football_medical_staff'),
        football_other_staff: t('football_other_staff'),
        football_team_manager: t('football_team_manager')
    }

    const itempx = (width - 10 * px) / 100

    return (
        <div
            id={id}
            style={{
                backgroundColor: color.bg,
                width: width,
                paddingBottom: isShowSponsor && sponsorData?.length > 0 ? px * 10 : px * 3,
                position: 'relative',
                overflow: 'hidden',
                fontFamily: 'SFUHelveticaCondensedBold'
            }}
        >
            {/* Diagonal texture */}
            <div style={{
                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0,
                backgroundImage: `repeating-linear-gradient(45deg, rgba(255,215,0,0.012) 0px, rgba(255,215,0,0.012) 1px, transparent 1px, transparent 10px)`
            }} />
            {/* Radial gold glow */}
            <div style={{ position: 'absolute', top: '20%', left: '50%', transform: 'translate(-50%, -50%)', width: `${px * 130}px`, height: `${px * 80}px`, background: 'radial-gradient(ellipse, rgba(255,215,0,0.06) 0%, transparent 70%)', zIndex: 0 }} />

            <div style={{ position: 'relative', zIndex: 1, padding: `${px * 2}px ${px * 2}px 0` }}>

                {/* ========== HEADER ========== */}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: `${px * 1.5}px` }}>

                    {/* Left: team logo + name */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                        <Image
                            src={teamData?.logo}
                            style={{
                                width: `${sizeItemLogo * 0.8}px`, height: `${sizeItemLogo * 0.8}px`,
                                objectFit: 'contain',
                                filter: `drop-shadow(0 0 ${px * 0.8}px rgba(255,215,0,0.8))`,
                                borderRadius: '50%'
                            }}
                        />
                        <p style={{ color: color.first, fontSize: `${px * 1.6}px`, textTransform: 'uppercase', textAlign: 'center', marginTop: `${px * 0.5}px`, fontWeight: 'bold' }}>{teamData?.name}</p>
                    </div>

                    {/* Center: league + title + team name */}
                    <div style={{ flex: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <Image src={seasonData?.logo} style={{ width: `${sizeItemLogo * 0.9}px`, height: `${sizeItemLogo * 0.9}px`, objectFit: 'contain', filter: `drop-shadow(0 0 ${px}px rgba(255,215,0,0.6))` }} />
                        <h1 style={{
                            fontSize: `${px * 4}px`, textTransform: 'uppercase', textAlign: 'center',
                            margin: `${px * 0.5}px 0`, fontWeight: 'bold', letterSpacing: `${px * 0.1}px`,
                            background: `linear-gradient(180deg, #FFF0A0 0%, #FFD700 50%, #B8860B 100%)`,
                            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
                            filter: `drop-shadow(0 0 6px rgba(255,215,0,0.4))`
                        }}>
                            {t('list_team_member')}
                        </h1>
                        <h2 style={{ color: color.text, fontSize: `${px * 2.2}px`, textTransform: 'uppercase', textAlign: 'center', margin: 0, fontWeight: 'bold' }}>{teamData?.name}</h2>
                    </div>

                    {/* Right: vsports logo + season */}
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Image src={bg} style={{ width: `${sizeItemLogo * 0.7}px`, objectFit: 'contain', filter: `drop-shadow(0 0 4px rgba(255,215,0,0.3))` }} />
                        <p style={{ color: color.fourth, fontSize: `${px * 1.5}px`, textTransform: 'uppercase', textAlign: 'center', marginTop: `${px * 0.5}px` }}>{seasonData?.name}</p>
                    </div>
                </div>

                {/* Gold divider */}
                <div style={{ width: '100%', height: `${px * 0.2}px`, background: `linear-gradient(90deg, transparent, ${color.first}, transparent)`, marginBottom: `${px * 2}px` }} />

                {/* ========== STAFF ========== */}
                {listPlayer?.football_staff_type?.length > 0 && checkboxStaff && (
                    <div style={{ marginBottom: `${px * 2}px` }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: `${px * 1.5}px` }}>
                            <div style={{ width: `${px * 0.5}px`, height: `${px * 3}px`, background: color.first, marginRight: `${px}px`, boxShadow: `0 0 6px rgba(255,215,0,0.6)` }} />
                            <h2 style={{ color: color.first, fontSize: `${px * 2.2}px`, textTransform: 'uppercase', margin: 0, letterSpacing: '1px' }}>{t('staff')}</h2>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                            {_staffs?.map((i, idx) => (
                                <div key={`${idx}+${i.id}`} style={{
                                    display: 'flex', width: `${((19.5 * itempx) / 50) * 40}px`,
                                    marginTop: `${((1.5 * itempx) / 50) * 40}px`, marginBottom: `${((1 * itempx) / 50) * 40}px`,
                                    alignItems: 'center', flexDirection: 'column', justifyContent: 'center'
                                }}>
                                    <Image onLoad={onLoaded} src={i.avatar || config.logo} style={{
                                        width: `${((23 * itempx) / 100) * 38}px`, height: `${((23 * itempx) / 100) * 38}px`,
                                        border: `${px * 0.3}px solid ${color.staffBorder}`,
                                        backgroundColor: 'rgba(10,10,10,0.9)',
                                        borderRadius: '50%', objectFit: 'cover',
                                        boxShadow: `0 0 10px rgba(255,215,0,0.4)`
                                    }} />
                                    <h3 style={{ marginTop: `${px * 0.4}px`, color: color.first, fontSize: `${itempx * 1.5}px`, textTransform: 'uppercase', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: `${((19.5 * itempx) / 50) * 40}px` }}>{staffPosition[i.positions[0]] || i?.positions[0]}</h3>
                                    <h3 style={{ color: color.text, fontSize: nameFontSize(i.name, itempx * 1.3), width: `${((19.5 * itempx) / 50) * 40}px`, textAlign: 'center', textTransform: 'uppercase', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{i.name}</h3>
                                    {isShowBirthDay && <h3 style={{ color: color.subText, fontSize: `${itempx * 1.2}px`, textAlign: 'center', whiteSpace: 'nowrap' }}>{formatDateTime(i.birthday, 'date')}</h3>}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Divider */}
                {listPlayer?.football_staff_type?.length > 0 && checkboxStaff && listPlayer?.football_player_type?.length > 0 && checkboxPlayer && (
                    <div style={{ width: '90%', height: `${px * 0.15}px`, background: `linear-gradient(90deg, transparent, rgba(255,215,0,0.25), transparent)`, margin: `0 auto ${px * 1.5}px` }} />
                )}

                {/* ========== PLAYERS ========== */}
                {listPlayer?.football_player_type?.length > 0 && checkboxPlayer && (
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: `${px * 1.5}px` }}>
                            <div style={{ width: `${px * 0.5}px`, height: `${px * 3}px`, background: color.third, marginRight: `${px}px`, boxShadow: `0 0 6px rgba(184,134,11,0.6)` }} />
                            <h2 style={{ color: color.fourth, fontSize: `${px * 2.2}px`, textTransform: 'uppercase', margin: 0, letterSpacing: '1px' }}>{t('player')}</h2>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                            {listPlayer?.football_player_type?.map((i, idx) => (
                                <div key={`${idx}+${i.id}`} style={{
                                    display: 'flex',
                                    width: `${((19.5 * itempx) / 50) * 40}px`,
                                    marginTop: (listPlayer?.football_staff_type?.length < 1 || !listPlayer?.football_staff_type) && idx < 7 ? `${((4 * itempx) / 50) * 100}px` : `${((1 * itempx) / 50) * 40}px`,
                                    marginBottom: `${((1 * itempx) / 50) * 40}px`,
                                    alignItems: 'center', flexDirection: 'column', justifyContent: 'center'
                                }}>
                                    <div style={{ position: 'relative' }}>
                                        <Image onLoad={onLoaded} src={i.avatar || config.logo} style={{
                                            width: `${((23 * itempx) / 100) * 38}px`, height: `${((23 * itempx) / 100) * 38}px`,
                                            border: `${px * 0.3}px solid ${color.playerBorder}`,
                                            backgroundColor: 'rgba(10,10,10,0.9)',
                                            borderRadius: '50%', objectFit: 'cover',
                                            boxShadow: `0 0 8px rgba(184,134,11,0.5)`
                                        }} />
                                        {/* Shirt number badge */}
                                        {i.shirtNumber != null && (
                                            <div style={{
                                                position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)',
                                                background: `linear-gradient(135deg, ${color.third}, ${color.first})`,
                                                borderRadius: `${px * 0.5}px`,
                                                padding: `${px * 0.1}px ${px * 0.4}px`,
                                                minWidth: `${px * 2.5}px`, textAlign: 'center'
                                            }}>
                                                <span style={{ color: '#0a0a0a', fontSize: `${itempx * 1.6}px`, fontWeight: 'bold', fontFamily: 'SFUHelveticaCondensedBold' }}>{i.shirtNumber}</span>
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ width: `${((18.5 * itempx) / 50) * 40}px`, marginTop: `${px * 0.3}px` }}>
                                        <h3 style={{
                                            color: color.text, fontSize: nameFontSize(i.name, itempx * 1.3),
                                            width: '100%', textAlign: 'center', textTransform: 'uppercase',
                                            fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                                        }}>{i.name}</h3>
                                        {isShowBirthDay && (
                                            <h3 style={{ color: color.subText, fontSize: `${itempx * 1.2}px`, textAlign: 'center', whiteSpace: 'nowrap' }}>{formatDateTime(i.birthday, 'date')}</h3>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* ========== SPONSOR BAR ========== */}
            {isShowSponsor && sponsorData?.length > 0 && (
                <div style={{
                    height: `${8 * px}px`, width: '100%',
                    position: 'absolute', bottom: `${px * 0.5}px`, padding: `${0.8 * px}px 0px`,
                    background: `linear-gradient(90deg, rgba(184,134,11,0.3), rgba(255,215,0,0.15), rgba(184,134,11,0.3))`,
                    border: `${px * 0.1}px solid rgba(255,215,0,0.3)`, zIndex: 2
                }}>
                    <div style={{ width: '95%', height: '100%', backgroundColor: 'rgba(10,10,10,0.85)', margin: '0 auto', borderRadius: `${3 * px}px`, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', border: `${px * 0.1}px solid rgba(255,215,0,0.2)` }}>
                        {sponsorData?.slice(0, 10)?.map((i, idx) => (
                            <Image key={idx} src={i.logo || config.logo} style={{ width: 'auto', maxHeight: `${px * 5}px`, backgroundColor: 'white', objectFit: 'cover', marginRight: `${2 * px}px`, borderRadius: `${px * 0.5}px` }} />
                        ))}
                    </div>
                </div>
            )}

            {/* Footer */}
            <p style={{ position: 'relative', zIndex: 1, textAlign: 'right', color: 'rgba(224,192,96,0.4)', fontSize: `${px * 1.5}px`, margin: `${px}px ${px * 2}px 0`, fontWeight: 'bold' }}>
                {window.sessionStorage.getItem('HomeUrl') || 'VSPORT EXCLUSIVE'}
            </p>
        </div>
    )
}

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props?.src?.includes('ui-avatars')) {
            getBase64(config.logo).then(r => setData(r))
        } else {
            getBase64(props.src).then(r => setData(r))
        }
    }, [props.src])
    return data ? <img {...props} src={data} onLoad={props.onLoad} alt="" /> : null
}

const areEqual = (p, n) => {
    return (
        JSON.stringify(p.players) === JSON.stringify(n.players) &&
        JSON.stringify(p.checkboxPlayer) === JSON.stringify(n.checkboxPlayer) &&
        JSON.stringify(p.checkboxStaff) === JSON.stringify(n.checkboxStaff) &&
        JSON.stringify(p.isShowBirthDay) === JSON.stringify(n.isShowBirthDay) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
    )
}

export default React.memo(PlayersList10, areEqual)
